// extracted by mini-css-extract-plugin
module.exports = {"iotktLogGrid":"iotktLog_iotktLogGrid__2-PBL","iotktLogG":"iotktLog_iotktLogG__3NM5x"};